import { render } from "./SeminarDetailsCompleted.vue?vue&type=template&id=ee2fdbf6&ts=true"
import script from "./SeminarDetailsCompleted.vue?vue&type=script&lang=ts"
export * from "./SeminarDetailsCompleted.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__